// IndexedDB-backed offline queue for timer mutations.
import { openDB } from "idb";

const DB = "km-offline";
const STORE = "queue";

async function db() {
    return openDB(DB, 1, {
        upgrade(d) {
            if (!d.objectStoreNames.contains(STORE)) {
                d.createObjectStore(STORE, { keyPath: "id", autoIncrement: true });
            }
        },
    });
}

export async function enqueue(item) {
    const d = await db();
    await d.add(STORE, { ...item, queued_at: Date.now() });
    return true;
}

export async function count() {
    const d = await db();
    return d.count(STORE);
}

export async function flush(apiClient) {
    // Read all pending items in a short RO transaction, then release the tx
    // before doing any network work. Delete each successfully replayed item
    // in its own tiny RW transaction. This avoids "transaction inactive" errors
    // that leave items un-deleted after the network round-trip completes.
    const d = await db();
    const items = await d.getAll(STORE);
    let ok = 0, fail = 0;
    for (const item of items) {
        try {
            await apiClient.request({
                url: item.url, method: item.method, data: item.body,
            });
            await d.delete(STORE, item.id);
            ok += 1;
        } catch (_) {
            fail += 1;
        }
    }
    return { ok, fail, total: items.length };
}

export function newClientOfflineId() {
    if (crypto?.randomUUID) return crypto.randomUUID();
    return `co-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
